const bjpCandidatesCastes: string[] = [
  `Number one candidate's caste`,
  `No. 2 candidate's caste`,
  `No. 3 candidate's caste`,
]

export default bjpCandidatesCastes
